import { FC, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import useFetch from "src/hooks/useFetch";
import { ToastContext } from "src/context/toastContext";

import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { RenderNextStepProps, statetype } from "./types";
import { PrecertAPIResponse } from "../precert/types";
import { LoaderContext } from "src/context/loaderContext";
import useAppealButtonFunc from "src/hooks/useAppealButtonFunc";



const RenderNextStep: FC<RenderNextStepProps> = ({ kase , showHideModalForTreatment, setDataForCancelModal, getCaseListing }): JSX.Element => {
  const [precertPathParameters, setPrecertPathParameters] = useState<statetype>()

  const navigate = useNavigate();
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { apiInPorgress } = useAppealButtonFunc();


  let caseAction;
  let precertButtons;
  let updateButtons;
  let reviewButtons;




  const { mutate: fetchPrecertMutate, data: fetchPrecertResponse } =
    useFetch<PrecertAPIResponse>(APIEndpoints.FETCH_PRECERT, {}, {}, false);

  useEffect(() => {
    if (fetchPrecertResponse) {
      navigate(`/cases/${precertPathParameters && precertPathParameters.case_id}/precerts/${precertPathParameters && precertPathParameters.id}/edit?insuranceName=${precertPathParameters && precertPathParameters.insurance_name}`);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchPrecertResponse]);

  const navigateToPrecertForm = (caseId: number, precertId: number,insuranceName:string) => {
    const pathParams = {
      case_id: caseId,
      id: precertId,
    }   
    fetchPrecertMutate({}, pathParams)
   let pathParam = {insurance_name:insuranceName, ...pathParams}
    setPrecertPathParameters(pathParam)
  }




  const { loading: transferRxLoading, data: transferRxData } =
    useFetch(APIEndpoints.TRANSFER_RX, {}, { case_id: kase.id });

  useEffect(() => {
    if (transferRxData) {
      const { message } = transferRxData as unknown as { code: number; message: string; };
      showToast([message], ToastTypes.SUCCESS);
      getCaseListing();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferRxData]);

  useEffect(() => {
    if (transferRxLoading) setLoader();
    else hideLoader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferRxLoading]);





  const navigateToReviewPrecertForm = (caseId: number, precertId: number, title: string,patient:string,insurance_name:string) => {
    console.log(caseId,"    ",precertId,"   ",title)

    navigate(
      `/cases/${caseId}/precerts/${precertId}/review?title=${title + " " + caseId}&patient=${patient}&insuranceName=${insurance_name}`,
    );
  }

  const navigateToUpdatePrecertForm = (caseId: number, precertId: number,patient:string,insurance_name:string) => {
    navigate(`/cases/${caseId}/precert/${precertId}/edit?patient=${patient}&insuranceName=${insurance_name}`);

  }
  

  if(kase && kase.precert_buttons.length >0 ){
    precertButtons = kase.precert_buttons.map((btn) =>
      btn.precert === true &&
        <button
          key={`precert-${btn.key}`}
          data-bs-toggle="tooltip"
          data-bs-placement="right"
          className= "btn btn-warning m-1 mt-2 mb-0 fw-normal fs-6 link-offset-0-hover link-underline-opacity-75-hover"
          title={`${btn.ins_name}`}
          disabled={apiInPorgress}
          onClick={() => navigateToPrecertForm(kase.id, btn.precert_id,btn.ins_name)}
        >
          <i className="bi bi-clipboard-check me-2"></i> {`Precert`}
        </button>
     
    );
  }
  
  if(kase && kase.update_buttons.length >0 ){
  updateButtons = kase.update_buttons.map((btn) =>
    btn.update === true &&
      <button
        key={`update-${btn.key}`}
        data-bs-toggle="tooltip"
        data-bs-placement="right"
        className= "btn btn-warning m-1 mt-2 mb-0 fw-normal fs-6 link-offset-0-hover link-underline-opacity-75-hover"
        title={`${btn.ins_name}`}
        disabled={apiInPorgress}
        onClick={() =>
          btn.precert_status === "submitted"
            ? navigateToUpdatePrecertForm(kase.id, btn.precert_id,kase.patient.firstlastname,btn.ins_name)
            : navigateToPrecertForm(kase.id, btn.precert_id,btn.ins_name)
        }
      >
        <i className="bi bi-pencil-square me-2"></i> {`Update PA`}
      </button>
    
  );
}
  if(kase && kase.review_buttons.length>0){

    reviewButtons = kase.review_buttons.map((btn) =>
      btn.review === true &&
        <button
          key={`review-${btn.key}`}
          data-bs-toggle="tooltip"
          data-bs-placement="right"
          className= "btn btn-warning m-1 mt-2 mb-0 fw-normal fs-6 link-offset-0-hover link-underline-opacity-75-hover"
          title={`${btn.ins_name}`}
          disabled={apiInPorgress}
          onClick={() =>
            navigateToReviewPrecertForm(kase.id, btn.precert_id, "Review Med PA For Case", kase.patient.firstlastname,btn.ins_name)
          }
        >
          <i className="bi bi-search me-2"></i>{`Review PA`}
        </button>
     
    );
  
  }
  if(kase && kase.no_action_required ){
    caseAction =
     <p className="fs-6 mb-0">No Action Required</p> 
  
  }
     
  
  return (
    <>
      {caseAction}
      {precertButtons}
      {reviewButtons}
      {updateButtons}
    </>
  );
};

export default RenderNextStep;
